/* eslint-disable prefer-const */
/* eslint-disable no-case-declarations */
import { Common } from '@/app/editor/sidebar/global-style/common';
import store from '@/app/store/store';
import { handleModifyItemStyle } from '@/utils/apply-preset';
import HELPER from '@/app/utils/HELPER';
import { base } from '../constant';
import { CLASS_GS_CUSTOM } from '@modules/editor-sidebar';
import emitter from '@/emitter';
import { DataSettingGlobalStyle } from '../../iframe/atom/service/data/DataSettingGlobalStyle';
import { replaceMap } from '@/constants/elements-map';
import { app } from '@/store';

/**
 *
 */
class TabSettings extends Common {
  public $gfLeftSideBar = jQuery('#gfLeftSideBar');

  public $mdSettings = this.$gfLeftSideBar.find('#md-settings');
  public $gfSGSubTitle = this.$mdSettings.find('.gfSGSubTitle');
  public timeOutApplySettingHasClassBySnippet: any;
  public timeOutUpdateClassWhenChangeSettingGlobalStyle: any;
  /**
   * constructor
   */
  constructor() {
    super();
    clearTimeout(this.timeOutApplySettingHasClassBySnippet);
    clearTimeout(this.timeOutUpdateClassWhenChangeSettingGlobalStyle);
  }

  /**
   * getGfLeftSideBar
   */
  getGfLeftSideBar() {
    this.$gfLeftSideBar = jQuery('#gfLeftSideBar');
    this.$mdSettings = this.$gfLeftSideBar.find('#md-settings');
    this.$gfSGSubTitle = this.$mdSettings.find('.gfSGSubTitle');
  }

  /**
   * initSettingGlobalStyle
   * dataKey: heading, text-block,...
   */
  initSettingGlobalStyle(dataKey = '', gsId = '', gsSettingGroupName = '') {
    if (!gsSettingGroupName) {
      return;
    }
    this.snippetType = dataKey;
    this.getGfLeftSideBar();
    const template = this.getTemplateByType(dataKey, gsId);
    const itemSettingGS: any = this.getSettingGlobalStyle(dataKey, gsId);
    const dataCaption = `.gfSGTitleBarTitle[data-caption="${gsSettingGroupName}"]`;
    if (itemSettingGS?.isSettingAdvand) {
      this.handleInitSettingAdvand(dataCaption, template);
    } else {
      this.handleInitSettingColumns(dataCaption, template);
    }
    this.applyEventForSelectGs(gsId);
  }

  /**
   * handleInitSettingAdvand
   * columns-advanced
   */
  handleInitSettingAdvand(dataCaption: any, template: any) {
    const $colAdvanced = this.$gfLeftSideBar.find('.columns-advanced');
    const length = $colAdvanced.length;
    for (let i = 0; i < length; i++) {
      const $this = $($colAdvanced[i]);
      const $gfSGTitleBarTitle = $this.find(dataCaption);
      if ($gfSGTitleBarTitle && $gfSGTitleBarTitle.length) {
        const $gfSettingGroup = $gfSGTitleBarTitle.closest('.gfSettingGroup');
        $gfSettingGroup.find('.gfSGSettings').prepend(template);
        ($gfSettingGroup.find('.gf_gs-icon-tooltip') as any).gfTooltipsNew({
          postion: 'top',
          desc: this.getMessageTooltipByType(),
          subTop: 5,
        });
      }
    }
    return;
  }

  /**
   * handleInitSettingColumns
   * columns
   */
  handleInitSettingColumns(dataCaption: any, template: any) {
    const $gfSGTitleBarTitle = this.$gfLeftSideBar.find(dataCaption);
    if ($gfSGTitleBarTitle && $gfSGTitleBarTitle.length) {
      const $gfSettingGroup = $gfSGTitleBarTitle.closest('.gfSettingGroup');
      $gfSettingGroup.find('.gfSGSettings').prepend(template);
      ($gfSettingGroup.find('.gf_gs-icon-tooltip') as any).gfTooltipsNew({
        postion: 'top',
        desc: this.getMessageTooltipByType(),
        subTop: 5,
      });
    }
    return;
  }

  /**
   * applyEventForSelectGs
   */
  applyEventForSelectGs(gsId = '') {
    this.getGfLeftSideBar();
    const $elSelectGs = this.$mdSettings.find('.settings-panel').find(`#${gsId}, #${gsId}-type, #${gsId}-style`);
    const _this = this;
    $elSelectGs.off('input-change').on('input-change', function (e, data) {
      const linkedPresetId = (app as any).$store.getters['sidebar/getLinkedPresetId'];
      if (!linkedPresetId) return;
      const valClassCurrent = $(this).val();
      const isClassCuttom = _this.hasClassGSCustom({ valClass: valClassCurrent });
      const currentClassBefore = data && data.valBeforeChange;
      const dataKey: any = _this.$mdSettings.find('.md-title .mer-title').attr('data-key');

      const isButtonsKey = ['button', 'submit-button', 'dynamic-button', 'p-cart-button', 'p-view-button'];

      if (isButtonsKey.includes(dataKey)) {
        emitter.emit('hook:changeButtonSetting');
        // set switch button hover
        _this.$gfLeftSideBar.find('#buttonHover').val('0').attr('value', '0').trigger('input-change');
      }

      const edittingID = _this.$mdSettings.data('edittingID');
      const merId = `#${edittingID}`;
      _this.visibleSettingGlobalStyle(dataKey);
      _this.updateValueGSToStore(merId, dataKey, gsId);
      _this.updateClassWhenChangeSettingGlobalStyle(dataKey, gsId, merId);
      if (isClassCuttom) {
        if (currentClassBefore) {
          _this.applyValueWhenUpdateClass(dataKey, gsId, currentClassBefore);
          _this.handleResetToDefault(dataKey, gsId);
          _this.responsiveStyle(dataKey, gsId, merId, currentClassBefore);
        }
      } else {
        const typeMer: any = _this.$mdSettings.attr('data-editting');
        _this.modifyStyleGS(typeMer, merId);
      }
    });
  }

  /**
   * updateValueGSToStore
   */
  updateValueGSToStore(merId: any, dataKey: any, gsId: any) {
    const attrId = this.getAttrIdMER(merId) || '';
    const itemSettingGS: any = this.getSettingGlobalStyle(dataKey, gsId);
    const isButtonTypeSetting = this.isButtonTypeSetting(itemSettingGS['typeSetting']);
    let valCurrentClassNew = this.$mdSettings.find(`#${gsId}`).val() || CLASS_GS_CUSTOM;
    if (isButtonTypeSetting) {
      const gsButtonSize = `#${gsId}-style`;
      const gsButtonType = `#${gsId}-type`;
      const gsButtonSizeClass: any = this.$mdSettings.find(gsButtonSize).val() || '';
      const gsButtonTypeClass: any = this.$mdSettings.find(gsButtonType).val() || CLASS_GS_CUSTOM;
      const isClassCuttom = this.hasClassGSCustom({ valClass: gsButtonTypeClass });
      valCurrentClassNew = gsButtonTypeClass;
      if (gsButtonSizeClass && gsButtonTypeClass && !isClassCuttom) {
        valCurrentClassNew = `${gsButtonTypeClass} ${gsButtonSizeClass}`;
      }
    }
    const dataSettingGlobalStyle = new DataSettingGlobalStyle(attrId);
    dataSettingGlobalStyle.updateValueGS({ gsId: gsId, class: valCurrentClassNew });
    return;
  }

  /**
   * responsiveStyle
   * dataKey: heading, text-block,...
   */
  responsiveStyle(dataKey: string, gsId: string, merId: string, currentClass: string) {
    const presetOption: any = this.getPresetOptionItem(dataKey, gsId, currentClass);
    const $gfFrame = jQuery('#gfFrame');

    if (presetOption && presetOption.value && Object.keys(presetOption.value).length) {
      const $gryffBody = $gfFrame.contents().find('body').first();
      const $mer = $gryffBody.find(merId);
      if (!$mer) {
        return;
      }
      const field = this.getSettingGroup(dataKey, gsId);
      const itemSettingGS = this.getSettingGlobalStyle(dataKey, gsId);
      const valueField = Object.values(field);
      if (!valueField) {
        return false;
      }
      const devices = ['xs', 'sm', 'md', 'lg'];

      let style = '';
      let $data: any;
      const targetClassElm = this.getTargetClassElm(dataKey, gsId);
      const isModule = targetClassElm.includes('{mID}');
      const isElement = targetClassElm.includes('{eID}');

      if (isElement) {
        $data = $mer.data('gfelement');
        style = $data && $data.getElementCSS(style);
      } else if (isModule) {
        $data = $mer.data('gfmodule');
        style = $data && $data.getModuleCSS();
      }
      for (let j = 0; j < devices.length; j++) {
        const screenT = devices[j];
        const deOptions: any = this.getDeOptionsScreen(presetOption, field, screenT);
        let objByDeOptions: any = this.groupSelectorDeOptions(deOptions);
        const objByDeOptionLength = Object.keys(objByDeOptions).length;
        for (let i = 0; i < objByDeOptionLength; i++) {
          const selector = Object.keys(objByDeOptions)[i];
          const items = objByDeOptions[selector].items;
          let targetSelector = this.getTargetSelectorBySelector($mer, selector, itemSettingGS);
          if (isElement) {
            style = HELPER.designOptions2Style($mer, screenT, style, items, targetSelector);
          } else if (isModule) {
            const targetSelectorNoHover = targetSelector.replace(':hover', '');
            const $self = $mer.find(targetSelectorNoHover);
            if (!$self || !$self.length) {
              continue;
            }
            style = HELPER.designOptions2Style($self, screenT, style, items, targetSelector);
          }
        }
      }
      if (isElement) {
        $data.setElementCSS(style);
      } else if (isModule) {
        $data.setModuleCSS(style);
      }
      return false;
    }
  }
  /**
   *groupSelectorDeOptions
   */
  groupSelectorDeOptions(deOptions: any) {
    let objByDeOptions: any = {};
    const deOptionLength = deOptions.length;
    for (let i = 0; i < deOptionLength; i++) {
      const deOptionItem = deOptions[i];
      const keySelector = deOptionItem?.selector ? deOptionItem.selector : '';
      if (!keySelector) continue;
      if (!objByDeOptions[keySelector]) {
        objByDeOptions[keySelector] = {};
        objByDeOptions[keySelector].items = [];
      }
      objByDeOptions[keySelector].items.push(deOptionItem);
    }
    return objByDeOptions;
  }

  /**
   * getDeOptionsScreen
   */
  getDeOptionsScreen(presetOption: any, field: any, screen: string) {
    const deOptions: any = [];
    const fieldLength: any = Object.keys(field).length;
    const hasDropShadow = presetOption?.value?.dropShadow?.enabled || false;
    for (let i = 0; i < fieldLength; i++) {
      const fieldKey = Object.keys(field)[i];
      const fieldItem = field[fieldKey];
      if (!fieldItem.cssAttr || (!hasDropShadow && fieldItem.cssAttr === 'box-shadow')) {
        continue;
      }
      let fieldValue: any = '';
      const fieldItemInherit = fieldItem?.inherit;
      const inherit =
        fieldItemInherit &&
        fieldItemInherit.replace(
          this.getLastInherit(fieldItemInherit),
          `screens.${screen}.${this.getLastInherit(fieldItemInherit)}`,
        );
      fieldValue = this.getValueDeepObjectByPath(presetOption, inherit);
      if (!fieldValue) {
        fieldValue = this.getValueDeepObjectByPath(presetOption, fieldItemInherit);
      }
      fieldValue = this.checkAndconvertValueHasUnit(fieldValue, fieldItem, presetOption);
      if (hasDropShadow && fieldItem.cssAttr === 'box-shadow') {
        const dropShadow = presetOption?.value?.dropShadow;
        const distance: any = (dropShadow.distance && this.detachUnitAndValue(dropShadow.distance)) || {};
        const size: any = (dropShadow.size && this.detachUnitAndValue(dropShadow.size)) || {};
        const blur: any = (dropShadow.blur && this.detachUnitAndValue(dropShadow.blur)) || {};
        const radian = dropShadow.angle * (Math.PI / 180);
        const x = Math.cos(radian) * parseFloat(distance.value);
        const y = Math.sin(radian) * parseFloat(distance.value);
        fieldValue = {
          x: x || 0,
          y: y || 0,
          blur: (blur && blur.value) || 0,
          spread: (size && size.value) || 0,
          color: dropShadow.color || 'transparent',
        };
      }

      const item = {
        key: fieldItem.cssAttr,
        value: fieldValue,
        selector: fieldItem?.selector,
      };
      deOptions.push(item);
    }

    return deOptions;
  }
  /**
   * getTargetSelectorBySelector
   * $mer: <div...id="e-1652943839486" data-key="heading">...</div>
   * selector: #{eID} .text-edit #{titleTag}
   */
  getTargetSelectorBySelector($mer: any, selector: string, itemSettingGS?: any) {
    if (itemSettingGS && itemSettingGS.selectorSupportModifyStyle) {
      const hover = ':hover';
      if (selector.includes(hover)) {
        selector = itemSettingGS.selectorSupportModifyStyle + hover || selector;
      } else {
        selector = itemSettingGS.selectorSupportModifyStyle || selector;
      }
    }
    let targetSelector = selector.replace('#{mID}', '').replace('#{eID}', '').trim();
    const isHasTitleTag = targetSelector.includes('#{titleTag}');
    if (isHasTitleTag) {
      const childElm = targetSelector.replace('#{titleTag}', '').trim();
      const $titleTag = $mer.find(childElm).children('h1,h2,h3,h4,h5,h6,p');
      let titleTag = '';
      if ($titleTag && $titleTag.prop('tagName')) {
        titleTag = $titleTag.prop('tagName').toLowerCase();
      }
      targetSelector = targetSelector.replace('#{titleTag}', titleTag);
    }
    return targetSelector;
  }
  /**
   * triggerSelectRenderGS
   */
  triggerSelectRenderGS($input: any, dataKey: string) {
    const keyInput = $input.attr('id') || $input.attr('name');
    const allFields = this.getAllFieldsByType(dataKey);
    if (allFields && allFields.length > 0 && allFields.includes(keyInput)) {
      return;
    }
    this.getGfLeftSideBar();
    const $selectGs = this.$mdSettings.find('.settings-panel, .general-panel').find('.gf_gs-select-render');
    if ($selectGs && $selectGs.length) {
      const itemLength = $selectGs.length;
      for (let item = 0; item < itemLength; item++) {
        const $itemThis: any = $($selectGs[item]);
        const currentClass = $itemThis && $itemThis.val();
        const isClassCuttom = this.hasClassGSCustom({ valClass: currentClass });
        if (currentClass && !isClassCuttom) {
          $itemThis.trigger('input-change');
        }
      }
    }
    return;
  }

  /**
   * visibleBoxSettingGlobalStyle
   * dataKey: heading, text-block,...
   */
  visibleBoxSettingGlobalStyle(dataKey = '', gsId = '', isButtonSetting: boolean) {
    const classes = this.getClassesByType(dataKey, gsId);
    this.getGfLeftSideBar();
    this.checkShowSettingFieldByIds(dataKey, gsId, classes, isButtonSetting);
    if (isButtonSetting) {
      this.checkShowSettingFieldByButton(gsId);
    }
    this.checkShowSettingColumns();
    this.addActionResetToDefaut(gsId);
    this.hideSettingHasClassGlobalStyle(dataKey, gsId);
    return false;
  }

  /**
   * getMessageTooltipByType
   */
  getMessageTooltipByType() {
    return 'You can apply styles that you setup in Global Styles';
  }

  /**
   * getTemplateByType
   * dataKey: heading, text-block,...
   */
  getTemplateByType(dataKey: string, gsId: string) {
    const itemSettingGS: any = this.getSettingGlobalStyle(dataKey, gsId);
    let template = '';
    switch (itemSettingGS['typeSetting']) {
      case 'heading':
        template = this.headingTemplate(gsId);
        break;
      case 'paragraph':
        template = this.paragraphTemplate(gsId);
        break;
      case 'button':
        template = this.buttonTemplate(`${gsId}-type`, `${gsId}-style`, itemSettingGS['buttonKey']);
        break;
      case 'heading-paragraph':
        template = this.headingParagraphTemplate(gsId);
        break;
    }
    return template;
  }

  /**
   * getOptionsByType
   * dataKey: heading, text-block,...
   */
  getOptionsByType(dataKey: string, gsId: string) {
    const itemSettingGS: any = this.getSettingGlobalStyle(dataKey, gsId);
    const options: any = {};
    switch (itemSettingGS['typeSetting']) {
      case 'heading':
        options[itemSettingGS['typeSetting']] = this.headingOptions();
        break;
      case 'paragraph':
        options[itemSettingGS['typeSetting']] = this.paragraphOptions();
        break;
      case 'button':
        options[itemSettingGS['typeSetting']] = {
          type: this.buttonTypeOptions(itemSettingGS['buttonKey']),
          style: this.buttonStyleOptions(),
        };
        break;
      case 'heading-paragraph':
        options[itemSettingGS['typeSetting']] = this.headingParagraphOptions();
        break;
    }
    return options;
  }

  /**
   * getSettingGroup
   * dataKey: heading, text-block,...
   */
  getSettingGroup(dataKey: string, gsId: string) {
    const elMapByType: any = this.getElMapByType(dataKey);
    const fields = elMapByType && elMapByType.settingGroups && elMapByType.settingGroups[gsId];
    return (fields && fields) || {};
  }

  /**
   * getFieldsByType
   * dataKey: heading, text-block,...
   */
  getFieldsByType(dataKey: string, gsId: string) {
    const field = this.getSettingGroup(dataKey, gsId);
    return (field && Object.keys(field)) || [];
  }
  /**
   * applySettingHasClassBySnippet
   * dataKey: heading, text-block,...
   */
  applySettingHasClassBySnippet(dataKey: string, itemSettingGS: any, merId = '') {
    const gsId = itemSettingGS?.gsId;
    const typeSetting = itemSettingGS?.typeSetting;
    const isButtonSetting = this.isButtonTypeSetting(typeSetting);
    if (!this.getPreset()) {
      this.renderSetupGlobalStyle(gsId, isButtonSetting);
      return;
    }
    const classes = this.getClassesByType(dataKey, gsId);
    const attrId = this.getAttrIdMER(merId) || '';
    const dataSettingGlobalStyle = new DataSettingGlobalStyle(attrId);
    const currentClass = dataSettingGlobalStyle.getCurrentClassGsByKey(gsId) || CLASS_GS_CUSTOM;
    const arrCurrenClass = typeof currentClass === 'string' ? currentClass.split(' ') : [];
    const isClassCuttom = this.hasClassGSCustom({ valClass: currentClass });
    let activeClass = CLASS_GS_CUSTOM;
    if (isButtonSetting) {
      let btnTypeClass = '';
      let btnSizeClass = '';

      const buttonSizeClasses = this.buttonSizeClass();
      arrCurrenClass.forEach((item: any) => {
        if (classes.includes(item)) {
          btnTypeClass = item;
        }
        if (buttonSizeClasses.includes(item)) {
          btnSizeClass = item;
        }
      });
      if (!btnTypeClass) {
        // CASE: Change Preset Other And Button Not Exist
        btnTypeClass = CLASS_GS_CUSTOM;
        dataSettingGlobalStyle.updateValueGS({ gsId: gsId, class: btnTypeClass });
        this.updateClassWhenChangeSettingGlobalStyle(dataKey, gsId, merId, isButtonSetting);
      }
      const gsButtonType = `#${gsId}-type`;
      const gsButtonSize = `#${gsId}-style`;
      this.$mdSettings.find(gsButtonType).attr('value', btnTypeClass).val(btnTypeClass).trigger('value-change');
      if (btnTypeClass && !isClassCuttom) {
        this.$mdSettings.find(gsButtonSize).attr('value', btnSizeClass).val(btnSizeClass).trigger('value-change');
      }
    } else {
      arrCurrenClass.forEach((item: any) => {
        if (classes.includes(item)) {
          activeClass = item;
        }
      });
      this.$mdSettings.find(`#${gsId}`).attr('value', activeClass).val(activeClass).trigger('value-change');
    }
  }

  /**
   * TODO:
   * updateClassWhenChangeSettingGlobalStyle
   */
  async updateClassWhenChangeSettingGlobalStyle(type = '', gsId = '', merId = '', isButtonSetting?: any) {
    if (!this.getPreset()) {
      return;
    }
    if (!isButtonSetting) {
      const itemSettingGS: any = this.getSettingGlobalStyle(type, gsId);
      isButtonSetting = this.isButtonTypeSetting(itemSettingGS['typeSetting']);
    }
    let classes = this.getClassesByType(type, gsId);
    const attrId = this.getAttrIdMER(merId) || '';
    const dataSettingGlobalStyle = new DataSettingGlobalStyle(attrId);
    const classCurrentEl = dataSettingGlobalStyle.getCurrentClassGsByKey(gsId);
    if (isButtonSetting) {
      const classBtnSize = this.buttonSizeClass();
      const classBorder = this.borderClass();
      const classCorner = this.cornerClass();
      classes = classes.concat(classBtnSize);
      classes = classes.concat(classBorder);
      classes = classes.concat(classCorner);
    }
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $mdSettings = jQuery('#md-settings');
    const merType = $mdSettings.attr('data-editting');
    const $mer = $gryffBody.find(merId);
    this.handleUpdateClassGs({
      mer: $mer,
      type: type,
      gsId: gsId,
      merId: merId,
      merType: merType,
      newClass: classCurrentEl,
      classRemove: classes.join(' '),
      isUpdateClassInDom: true,
    });
    HELPER.flagListItemChange($mer, 'settings');
    if (HELPER.isInsideTheList($mer)) {
      const $itemContent = $mer.closest('.item-content');
      await HELPER.newDetectContentChange($itemContent);
    }
  }

  /**
   * checkShowSettingFieldByIds
   * dataKey: heading, text-block,...
   */
  checkShowSettingFieldByIds(dataKey = '', gsId = '', classes: any = [], isButtonSetting = false) {
    if (!this.getPreset()) return;
    this.getGfLeftSideBar();
    const fields = this.getFieldsByType(dataKey, gsId);
    // TODO:
    const $settingsPanel = this.$mdSettings.find('.settings-panel');
    const currentGsId = $settingsPanel.find(`#${gsId}, #${gsId}-type`).val() || CLASS_GS_CUSTOM;
    let isShow = true;
    const isClassCuttom = this.hasClassGSCustom({ valClass: currentGsId });
    if (currentGsId && classes.includes(currentGsId) && !isClassCuttom) {
      isShow = false;
    }
    let buttonHoverVal: any = '';
    for (const id of fields) {
      const $caption = $settingsPanel.find(`#${id}, .${id}, [name="${id}"]`).not('[data-font-picker]');
      if (isButtonSetting && isShow) {
        if (id == 'buttonHover') {
          buttonHoverVal = $settingsPanel.find(`#${id}`).val();
        }
        // if buttonHover is 0 hide button color hover, color hover
        if (buttonHoverVal == '0' && ['button-color-hover', 'color-hover', 'text-color-hover'].includes(id)) {
          continue;
        }
      }
      if ($caption) {
        const $boxSetting = $caption.next();
        if (!$boxSetting.hasClass(gsId)) {
          $boxSetting.addClass(gsId);
        }
        this.handleVisibleSetting(dataKey, gsId, $boxSetting, isShow);
      }
    }
  }

  /**
   * handleVisibleSetting
   * dataKey:\,...
   */
  handleVisibleSetting(dataKey = '', gsId: string, $boxSetting: any, isShow: boolean) {
    isShow ? $boxSetting.show() : $boxSetting.hide();
    const itemSettingGS: any = this.getSettingGlobalStyle(dataKey, gsId);
    if (itemSettingGS?.isSettingAdvand) {
      const $columnsAdvanced = $boxSetting.closest('.columns-advanced');
      if ($columnsAdvanced.data('gfsettinggroup') != undefined) {
        $columnsAdvanced.data('gfsettinggroup').resizePopupAdvanced($columnsAdvanced, true);
      }
    }
  }

  /**
   * checkShowSettingFieldByButton
   */
  checkShowSettingFieldByButton(gsId = '') {
    const gsButtonType = `${gsId}-type`;
    const gsButtonSize = `${gsId}-style`;
    const currentGsClass = this.$mdSettings.find(`#${gsButtonType}`).val() || CLASS_GS_CUSTOM;
    const isClassCuttom = this.hasClassGSCustom({ valClass: currentGsClass });
    const $elDropdownId = this.$mdSettings.find(`#gf_gs-group-setting-${gsButtonSize}`);
    // const $elSubTitle = this.$mdSettings.find(`#gfSGSubTitle_${gsButtonSize}`);
    if (currentGsClass && !isClassCuttom) {
      $elDropdownId.show();
      // $elSubTitle.show();
    } else {
      $elDropdownId.hide();
      // $elSubTitle.hide();
    }
  }

  /**
   * renderColumn
   */
  renderColumn(gsSettingGroupName = '') {
    if (!gsSettingGroupName) {
      return;
    }
    this.getGfLeftSideBar();
    const html = `<div class="columns">
      <div class="gfSGBackground"></div>
      <div class="gfSettingGroup">
          <div class="gfSGBarHover">
          </div>
          <div class="gfSGTitleBar">
          <div class="gfSGTitleBarTitle" data-caption="${gsSettingGroupName}">${gsSettingGroupName}</div>
          </div>
          <div class="gfSGResponsive"></div>
          <div class="gfSGSettings">
          </div>
      </div>
      <div class="gfSGPopup"></div>
    </div>`;
    this.$mdSettings.find('.settings-panel .rows').prepend(html);
  }

  /**
   * addActionResetToDefaut
   */
  addActionResetToDefaut(gsId: string) {
    const $mdSettings = this.$mdSettings;
    const $gfDropDown = $mdSettings.find(`#gfDropDown_${gsId}, #gfDropDown_${gsId}-type`);
    const $btnSelect = $gfDropDown.find('.gfDropDownBody span.gf_gs-select');
    $btnSelect.find('.reset').remove();
    const valClassCurrent = $mdSettings.find(`#${gsId}, #${gsId}-type`).val() || CLASS_GS_CUSTOM;
    const isClassCuttom = this.hasClassGSCustom({ valClass: valClassCurrent });
    if (valClassCurrent && !isClassCuttom) {
      const actionReset = `<div class="reset"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2312 3.15835C10.9895 2.43352 12.2253 2.45145 12.9328 3.20751C13.6403 3.96357 13.5892 5.21159 12.8309 5.93642L10.2978 8.35757C9.53948 9.0824 8.30368 9.06446 7.59617 8.30841C7.40302 8.10201 7.0802 8.09359 6.87511 8.28961C6.67003 8.48564 6.66035 8.81187 6.8535 9.01827C7.96003 10.2007 9.84241 10.2088 10.9973 9.10501L13.5303 6.68386C14.6852 5.58003 14.782 3.68011 13.6755 2.49765C12.569 1.31519 10.6866 1.30707 9.53175 2.4109L6.99869 4.83205C6.79361 5.02807 6.78393 5.3543 6.97708 5.5607C7.17022 5.76711 7.49305 5.77552 7.69814 5.57949L10.2312 3.15835ZM6.54018 7.46011C7.04668 7.47016 7.52341 7.68289 7.86675 8.04979C8.0599 8.25619 8.38273 8.26461 8.58781 8.06858C8.79289 7.87256 8.80257 7.54633 8.60942 7.33993C8.07778 6.77181 7.34174 6.44493 6.56448 6.42949C5.78752 6.41407 5.03295 6.71096 4.46566 7.25319L1.9326 9.67433C1.36531 10.2166 1.02996 10.9614 1.00191 11.7463C0.973848 12.5315 1.25578 13.2924 1.78741 13.8605C2.31905 14.4287 3.05509 14.7556 3.83235 14.771C4.60932 14.7864 5.36389 14.4895 5.93118 13.9473L8.46423 11.5261C8.66932 11.3301 8.67899 11.0039 8.48585 10.7975C8.2927 10.5911 7.96987 10.5827 7.76479 10.7787L5.23173 13.1999C4.85849 13.5566 4.36346 13.7504 3.85666 13.7404C3.35016 13.7303 2.87343 13.5176 2.53009 13.1507C2.18674 12.7838 2.00315 12.2909 2.02144 11.7792C2.03973 11.2673 2.25881 10.7785 2.63205 10.4218L5.16511 8.00063C5.53835 7.64388 6.03338 7.45005 6.54018 7.46011ZM4.07673 1.03635C4.26857 0.946077 4.49586 1.02973 4.58441 1.22319L5.27346 2.72873C5.362 2.92219 5.27826 3.15221 5.08642 3.24248C4.89458 3.33276 4.66729 3.24911 4.57874 3.05565L3.88969 1.5501C3.80115 1.35664 3.88489 1.12663 4.07673 1.03635ZM11.4604 14.7768C11.549 14.9703 11.7763 15.0539 11.9681 14.9636C12.1599 14.8734 12.2437 14.6434 12.1551 14.4499L11.4661 12.9444C11.3775 12.7509 11.1502 12.6672 10.9584 12.7575C10.7666 12.8478 10.6828 13.0778 10.7714 13.2713L11.4604 14.7768ZM3.62038 4.89771C3.51131 5.08261 3.27117 5.15398 3.084 5.05711L1.23964 4.10258C1.05248 4.00572 0.989163 3.7773 1.09823 3.5924C1.20729 3.4075 1.44743 3.33613 1.6346 3.433L3.47896 4.38752C3.66613 4.48439 3.72944 4.71281 3.62038 4.89771ZM12.9608 10.9429C12.7737 10.846 12.5335 10.9174 12.4244 11.1023C12.3154 11.2872 12.3787 11.5156 12.5659 11.6125L14.4102 12.567C14.5974 12.6639 14.8375 12.5925 14.9466 12.4076C15.0557 12.2227 14.9923 11.9943 14.8052 11.8974L12.9608 10.9429Z" fill="currentColor"/>
      </svg></div>`;
      $btnSelect.append(actionReset);

      ($btnSelect.find('.reset') as any).gfTooltipsNew({
        postion: 'top',
        subTop: 5,
        backgroundColor: '#676767',
        desc: 'Unlink style',
      });

      $btnSelect
        .find('.reset')
        .off('click')
        .on('click', function () {
          $gfDropDown.find('li.gf_gs-custom').trigger('click');

          $gfDropDown.find('ul.gf_gs-select').addClass('active');

          (document as any).getElementById('gfTooltipsNew').innerHTML = '';
        });
    }
  }

  /**
   * handleResetToDefault
   */
  handleResetToDefault(type: any, gsId: string): void {
    const obKeyField = this.getFieldsByType(type, gsId);
    const length = obKeyField.length;
    const itemSettingGS: any = this.getSettingGlobalStyle(type, gsId);
    if (this.isButtonTypeSetting(itemSettingGS['typeSetting'])) {
      const $gfTabs = this.$gfLeftSideBar.find('.simple-tabs');
      if ($gfTabs?.data('gftabs')) {
        $gfTabs.data('gftabs').onDesignOptionsTabClick(true);
      }
    }
    for (let i = 0; i < length; i++) {
      const key = obKeyField[i];
      const $inputItem = this.$mdSettings
        .find('.settings-panel, .general-panel')
        .find(`#${key}, .${key}, [name="${key}"]`);
      const $inputItemDS = this.$mdSettings.find('.design-panel').find(`#${key}, .${key}, [name="${key}"]`);
      if (this.isButtonTypeSetting(itemSettingGS['typeSetting'])) {
        $inputItem.trigger('value-change').trigger('input-change');
        $inputItemDS.trigger('gs-input-change');
      } else {
        $inputItem.trigger('value-change').trigger('input-change');
      }

      const $gfDropDown = $inputItem.next('.gfFontSelect');
      if ($gfDropDown.hasClass('gfFontSelect')) {
        const valueInput: any = $inputItem.val() ? $inputItem.val() : '';
        $gfDropDown.find('select').val(valueInput).trigger('value-change');
      }
    }
    store.setValue('handeResetToDefaultGS', '');
    return;
  }

  /**
   * getElement
   */
  getElement(type = '', gsId = '', merId = '', merSub = '') {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    let strEl = this.getTargetClassElm(type, gsId);
    strEl = replaceMap(strEl, merId, '');
    if (merSub) {
      return $gryffBody.find(strEl).find(merSub);
    } else {
      return $gryffBody.find(strEl);
    }
  }

  /**
   * setCurrentGsId
   */
  setCurrentGsId(isButtonType: boolean, gsId = '') {
    if (isButtonType) {
      return (gsId = `${gsId}-type`);
    } else {
      return gsId;
    }
  }

  /**
   * checkShowSettingColumns
   */
  checkShowSettingColumns(): void {
    const $columns = this.$mdSettings.find('.columns');
    const length = $columns.length;
    for (let i = 0; i < length; i++) {
      const $this = $($columns[i]);
      const $items = $this.find('.gfSGSettings').children('div');
      if (!$items || !$items.length) {
        continue;
      }
      let isShow = false;
      const itemLength = $items.length;
      for (let item = 0; item < itemLength; item++) {
        const $itemThis = $($items[item]);
        const display = $itemThis.css('display');
        if (display !== 'none') {
          isShow = true;
          break;
        }
      }
      if (isShow) {
        $this.show();
      } else {
        $this.hide();
      }
    }
  }

  /**
   * getPrefixClassType
   */
  getPrefixClassType(type = '', gsId = '') {
    const itemSettingGS: any = this.getSettingGlobalStyle(type, gsId);
    return itemSettingGS['prefix'];
  }

  /**
   * applyValueWhenUpdateClass
   * dataKey: heading, text-block,...
   */
  applyValueWhenUpdateClass(dataKey = '', gsId = '', className: any = '') {
    if (!className) {
      className = this.$mdSettings.find(`#${gsId}, #${gsId}-type`).val() || CLASS_GS_CUSTOM;
    }

    const presetOption: any = this.getPresetOptionItem(dataKey, gsId, className);
    const fields = this.getSettingGroup(dataKey, gsId);
    this.applyValueInputGs(this.$mdSettings, presetOption, fields);
    return false;
  }

  /**
   * initGlobalStyleClass
   */
  initGlobalStyleClass(param: any) {
    this.handleUpdateClassGs(param);
    return;
  }

  /**
   * handleCheckAndUpdateClassFolowPreset
   */
  handleCheckAndUpdateClassFolowPreset($gryffeditor: any) {
    const oldLinkedPresetId = (app as any).$store.getters['sidebar/getOldLinkedPresetId'];
    const linkedPresetId = (app as any).$store.getters['sidebar/getLinkedPresetId'];
    if (+oldLinkedPresetId && +oldLinkedPresetId !== +linkedPresetId) {
      const dataButton = this.getDataButtonType(true, oldLinkedPresetId, true) || [];
      const classDataButton = dataButton && dataButton.length > 0 ? dataButton.map((item: any) => item?.class) : [];
      // const dataCorner = this.getDataCorner(true, oldLinkedPresetId)|| [];
      // const classDataCorner = dataCorner && dataCorner.length > 0 ? dataCorner.map((item: any) => item?.class) : [];
      // const dataBorder = this.getDataBorder(true, oldLinkedPresetId)|| [];
      // const classDataBorder = dataBorder && dataBorder.length > 0 ? dataBorder.map((item: any) => item?.class) : [];
      // const dataSpacing = this.getDataSpacing(true, oldLinkedPresetId)|| [];
      // const objectSpacing = this.convertDataSpacingByClass(dataSpacing) || {};
      // const arrSpacing = objectSpacing && Object.keys(objectSpacing) || [];
      // const classDataSpacing = dataSpacing && dataSpacing.length > 0 ? dataSpacing.map((item: any) => item?.class) : [];
      const arrClassRemove = [
        ...classDataButton,
        // ...classDataCorner,
        // ...classDataBorder,
        // ...arrSpacing
      ];
      const lengthArr = arrClassRemove.length;
      const classRemove = arrClassRemove.join(' ');
      for (let i = 0; i < lengthArr; i++) {
        const itemClass = arrClassRemove[i];
        if (!itemClass) continue;
        const isAddClassCustom = itemClass && itemClass.includes('gf_gs-button-');
        const $target = $gryffeditor.find('.' + itemClass);
        const lengthTarget = $target.length;
        if (!lengthTarget) continue;
        for (let k = 0; k < lengthTarget; k++) {
          let $itemChild = $target && $target.eq(k);
          if ($itemChild) {
            const $mer = $target && HELPER.getParentMERByChild($itemChild);
            const dataKey = $mer && HELPER.getDataKeyMER($mer);
            const merType = $mer && HELPER.getDataTypeMER($mer);
            const merId = $mer && HELPER.getDataIdMER($mer);
            this.handleUpdateClassGs({
              mer: $mer,
              type: dataKey,
              merId: merId,
              merType: merType,
              newClass: isAddClassCustom ? CLASS_GS_CUSTOM : '',
              classRemove: classRemove,
              isUpdateClassInDom: true,
              isApplyNewPreset: true,
              isUpdateDataGlobalStyle: true,
            });
          }
        }
      }
    }
    return;
  }

  // INIT GLOBAL STYLE
  /**
   * initGlobalStyle
   * dataKey: heading, text-block,...
   */
  initGlobalStyle(dataKey = ''): any {
    const settingGS = this.getSettingGlobalStyles(dataKey);
    const settingGSLength = settingGS.length;
    if (settingGSLength > 0) {
      for (let index = 0; index < settingGSLength; index++) {
        const itemSettingGS = settingGS[index];
        if (itemSettingGS?.isRenderColumn) {
          // Support Setting Module has no required column
          this.renderColumn(itemSettingGS['gsSettingGroup']);
        }
        this.initSettingGlobalStyle(dataKey, itemSettingGS['gsId'], itemSettingGS['gsSettingGroup']);
      }
      this.applyEventEditStyle(this.$gfLeftSideBar);
    }
    // Change preset
    store.unset('currentPresetInPage');
    store.onChange('currentPresetInPage', () => {
      const settingGS = this.getSettingGlobalStyles(dataKey);
      const settingGSLength = settingGS.length;
      if (settingGSLength > 0) {
        for (let index = 0; index < settingGSLength; index++) {
          const itemSettingGS = settingGS[index];
          const gsId = itemSettingGS['gsId'];
          const options = this.getOptionsByType(dataKey, gsId);
          const typeSetting = itemSettingGS['typeSetting'];
          switch (typeSetting) {
            case 'button':
              const list = ['type', 'style'];
              const classes = this.getClassesByType(dataKey, gsId);
              const beforeValueButtonType = this.$mdSettings.find(`#${gsId}-type`).val();
              for (let i = 0; i < list.length; i++) {
                const typeButton = list[i];
                const gsIdButtonType = `#${gsId}-${typeButton}`;
                this.$mdSettings.find(`#gfDropDown_${gsId}-${typeButton}`).remove();
                this.$mdSettings.find(gsIdButtonType).removeData();
                this.$mdSettings.find(gsIdButtonType).html(options[typeSetting][typeButton]);
                (this.$mdSettings.find(gsIdButtonType) as any).gfDropDown({});
              }
              if (beforeValueButtonType && !classes.includes(beforeValueButtonType)) {
                this.setDefaultValueButtonWhenClassCustomNotExits();
              }
              break;
            default:
              this.$mdSettings.find(`#gfDropDown_${gsId}`).remove();
              this.$mdSettings.find(`#${gsId}`).removeData();
              this.$mdSettings.find(`#${gsId}`).html(options[typeSetting]);
              (this.$mdSettings.find(`#${gsId}`) as any).gfDropDown({});
              break;
          }
          const isOpenSetting = this.$mdSettings.hasClass('active');
          if (isOpenSetting) {
            let dataId = this.$mdSettings.data('edittingID');
            const merId = `#${dataId}`;
            const $gfFrame = jQuery('#gfFrame');
            const $gryffBody = $gfFrame.contents().find('body').first();
            $gryffBody.find(merId).find('.t-handle .gf-tool-label').trigger('click');
            this.applySettingHasClassBySnippet(dataKey, itemSettingGS, merId);
            this.visibleBoxSettingGlobalStyle(dataKey, gsId, this.isButtonTypeSetting(typeSetting));
          }
        }
      }
      this.applyEventEditStyle(this.$gfLeftSideBar);
    });
    return false;
  }

  /**
   * visibleSettingGlobalStyle
   */
  visibleSettingGlobalStyle(type = ''): any {
    const settingGS = this.getSettingGlobalStyles(type);
    const settingGSLength = settingGS.length;
    if (settingGSLength > 0) {
      for (let index = 0; index < settingGSLength; index++) {
        const itemSettingGS = settingGS[index];
        this.visibleBoxSettingGlobalStyle(
          type,
          itemSettingGS['gsId'],
          this.isButtonTypeSetting(itemSettingGS['typeSetting']),
        );
      }
    }
    return false;
  }

  /**
   * updateClassGlobalStyle
   */
  updateClassGlobalStyle(inputAttrId: any, type: string, targetId: any, tag?: any): any {
    // eslint-disable-next-line no-console
    const settingGS = this.getSettingGlobalStyles(type);
    const settingGSLength = settingGS.length;
    if (settingGSLength > 0) {
      for (let index = 0; index < settingGSLength; index++) {
        const itemSettingGS = settingGS[index];
        const gsId = itemSettingGS['gsId'];
        const isButtonTypeSetting = this.isButtonTypeSetting(itemSettingGS['typeSetting']);
        const isInputSetting = inputAttrId.includes(gsId);
        if (isInputSetting) {
          this.updateClassWhenChangeSettingGlobalStyle(type, gsId, targetId, isButtonTypeSetting);
          return false;
        }
      }
    }
    return false;
  }

  /**
   * checkInputGlobalStyle
   */
  checkInputGlobalStyle(type: string, $input: any) {
    if (!$input || !$input.length) {
      return false;
    }
    const settingGS = this.getSettingGlobalStyles(type);
    const legSettingGS = settingGS ? settingGS.length : 0;
    if (legSettingGS) {
      for (let ind = 0; ind < legSettingGS; ind++) {
        const itemSettingGS = settingGS[ind];
        const gsId = itemSettingGS?.gsId;
        const $inputGlobalStyle =
          ($input.attr('id') && $input.attr('id').includes(gsId)) ||
          ($input.attr('class') && $input.attr('class').includes(gsId)) ||
          ($input.attr('name') && $input.attr('name').includes(gsId));
        if ($inputGlobalStyle) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * applySettingSnipetGlobalStyle
   */
  applySettingSnipetGlobalStyle(type: string, targetId: any, tag?: string): any {
    const settingGS = this.getSettingGlobalStyles(type);
    const settingGSLength = settingGS.length;
    if (settingGSLength > 0) {
      for (let index = 0; index < settingGSLength; index++) {
        const itemSettingGS = settingGS[index];
        this.applySettingHasClassBySnippet(type, itemSettingGS, targetId);
      }
    }
    return false;
  }

  /**
   * modifyStyleGS
   */
  modifyStyleGS(type: any = '', merId: any = '') {
    if (!type) {
      type = this.$mdSettings.attr('data-editting');
    }
    if (!merId) {
      const edittingID = this.$mdSettings.data('edittingID');
      merId = `#${edittingID}`;
    }
    const key: any = this.$mdSettings.find('.md-title .mer-title').attr('data-key');
    const dataId = merId.replace('#e-', '').replace('#m-', '').replace('#r-', '');
    const $gfFrameContents = jQuery('#gfFrame').contents();
    const keyStyle = HELPER.getKeyDataSetting(base._style, dataId, type);
    const newStyle = handleModifyItemStyle({ keyStyle, gfFrameContents: $gfFrameContents, key, merId });
    return newStyle;
  }

  /**
   * hideSettingHasClassGlobalStyle
   */
  hideSettingHasClassGlobalStyle(type: string, gsId: string) {
    if (!type || !gsId) return;
    const settingGS = this.getSettingGlobalStyles(type);
    // TODO:
    const valClassCurrent = this.$mdSettings.find(`#${gsId}, #${gsId}-type`).val() || CLASS_GS_CUSTOM;
    const isClassCuttom = this.hasClassGSCustom({ valClass: valClassCurrent });
    const hideColumns = settingGS?.[0]?.hideColumns;
    if (!hideColumns || !hideColumns.length) return;
    const length = hideColumns.length;
    for (let i = 0; i < length; i++) {
      const $elColumn = this.$mdSettings.find(`.columns[data-caption='${hideColumns[i]}']`);
      if (valClassCurrent && !isClassCuttom) {
        $elColumn.hide();
      } else {
        $elColumn.show();
      }
    }
  }

  /**
   * setDefaultValueButtonWhenClassCustomNotExits
   */
  setDefaultValueButtonWhenClassCustomNotExits() {
    const fields = ['color', 'button-color', 'text-color'];
    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const field = fields[i];
      this.$mdSettings.find(`#${field}`).attr('value', '').val('').trigger('input-change');
    }
  }
}

export const renderTabSettings = new TabSettings();
